__webpack_require__.p = "https://cdn.gladly.qa/assets/agent-desktop/f7ac84409449cd91f494bf7e01ef77ef3a296ccb/admin/";